import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_token'

export function getBaseURL() {
  console.log(location.origin)
  // const baseURL = 'http://127.0.0.1:8000' // 开发服务器
 const baseURL = 'https://ielts.honeybee-edu.com' // 正式服务器






 
  // const baseURL = 'https://test.honeybee-edu.cn' // 测试服务器
  // const baseURL = 'http://fenwei.com/' // 本地服务器
   //  const baseURL = location.origin // 打包地址
  return baseURL
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js